import React from 'react';
import { Link } from 'react-router-dom';
import './ConsultingCTA.css';

const ConsultingCTA = () => {
  return (
    <section className="consulting-cta-section">
      <div className="consulting-cta-container">
        {/* Left side content */}
        <div className="cta-content">
          <div className="cta-header">
            <h4>Consulting</h4>
            <div className="cta-line"></div>
          </div>
          {/* This is a placeholder for the quesrow logo. 
              You can replace this with an <img /> tag if you have the logo file. */}
          {/* <div className="cta-logo-placeholder">
            quesrow
          </div> */}
          <p>
            Explore strategic consulting solutions powered by our trusted partners to build growth-focused strategies, create scalable plans, and adapt continuously with dynamic market intelligence.
          </p>
        </div>

        {/* Right side button */}
        <div className="cta-button-container">
          <Link to="/Consulting">
            <button className="explore-more-btn">Explore more</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ConsultingCTA;